export default "__VITE_ASSET__iD7AmHGA__"